import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
// Placeholder components for other routes
const Placeholder = ({
  title
}: {
  title: string;
}) => <div className="min-h-screen flex items-center justify-center bg-slate-50" data-id="element-0">
    <div className="text-center" data-id="element-1">
      <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-2">{title}</h1>
      <p className="text-slate-600" data-id="element-3">This page is under construction.</p>
      <a href="/" className="text-blue-600 hover:underline mt-4 inline-block" data-id="element-4">
        Return Home
      </a>
    </div>
  </div>;
export function App() {
  return <Router data-id="element-5">
      <Routes data-id="element-6">
        <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
        <Route path="/solutions" element={<Placeholder title="Solutions" data-id="element-10" />} data-id="element-9" />
        <Route path="/services" element={<Placeholder title="Services" data-id="element-12" />} data-id="element-11" />
        <Route path="/case-studies" element={<Placeholder title="Case Studies" data-id="element-14" />} data-id="element-13" />
        <Route path="/resources" element={<Placeholder title="Resources" data-id="element-16" />} data-id="element-15" />
        <Route path="/about" element={<Placeholder title="About Us" data-id="element-18" />} data-id="element-17" />
        <Route path="/ai-readiness" element={<Placeholder title="AI Readiness Assessment" data-id="element-20" />} data-id="element-19" />
        <Route path="/contact" element={<Placeholder title="Contact Us" data-id="element-22" />} data-id="element-21" />
        <Route path="*" element={<Placeholder title="404 - Page Not Found" data-id="element-24" />} data-id="element-23" />
      </Routes>
    </Router>;
}